import React, {Component} from 'react';
import toastr from "toastr";
import http from "../../services/httpService";
import {getJwt, getCurrentUserName} from "../../services/authService";

import PerformanceReport from "./tooltips/PerformanceReport";
import NotificationStatistics from "./tooltips/NotificationStatistics";
import SubscribersHistory from "./tooltips/SubscribersHistory";
import SubscribersPerChannel from "./tooltips/SubscribersPerChannel";
import TotalSubscribers from "./tooltips/TotalSubscribers";
import LatestPost from "./tooltips/LatestPost";
import * as authService from "../../services/authService";

// import ReactGA from "react-ga";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state =
            {
                subscribers_data: {
                    data: []
                },
                //mock_data: {
                //    data: []
                //},
                selected_source: props.selectedSource,
                //feeds_shared: props.feeds_shared,
                time_span: 7,
                loader: false,
                planName: '',
                interval: ''
            };

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }

    _isMounted = false;

    componentDidMount = async () => {
        // ReactGA.pageview(window.location.pathname + window.location.search);

        this._isMounted = true;
        try {
            this.setState({loader: true});
            //added MOCK
            const selected_source = this.props.selectedSource;
            const {time_span} = this.state;

            if (selected_source) {
                this.props.loadingSourceChange(true);

                const result = await http.get('api/subscriber_data/' + selected_source + '/time_span/' + time_span, {headers: {authorization: getJwt()}});
                this.props.loadingSourceChange(false);

                const data = await result.data;

                if (this._isMounted) {
                    this.setState({
                        subscribers_data: data.data,

                    });
                }
                //added MOCK
                //this.setState({mock_data: data.data});
            }
            await this.props.checkIfProjectPlanSelected();
            this.setState({loader: false})
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                //let errors = { ...this.state.errors }
                //console.log(ex.response.data);
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    }


    componentDidUpdate = async () => {
        const {
            selected_source,
            //feeds_shared,
            time_span
        } = this.state;

        let selectedProject = this.props.sources.find(source => source.id.toString() === selected_source.toString());
        //let selectedFeedSharedData = feeds_shared ? feeds_shared.find((source) => source.project_id.toString() === selected_source.toString()) : []

        if ((selected_source !== this.props.selectedSource) || (selectedProject && selectedProject.plan &&
            selectedProject.plan.name && selectedProject.plan.name !== this.state.planName)
            //|| (selectedFeedSharedData && selectedFeedSharedData.plan && selectedFeedSharedData.plan.name && selectedFeedSharedData.plan.name!== this.state.planName)
        ) {
            this.setState({
                planName: selectedProject && selectedProject.plan && selectedProject.plan.name ? selectedProject.plan.name :
                    //selectedFeedSharedData && selectedFeedSharedData.plan && selectedFeedSharedData.plan.name ? selectedFeedSharedData.plan.name :
                    '',
                interval: selectedProject && selectedProject.plan && selectedProject.plan.interval ? selectedProject.plan.interval : ''
            })
        }

        if (selected_source !== this.props.selectedSource) {
            this.setState({selected_source: this.props.selectedSource});

            //const result = await http.get('api/user/'+getCurrentUserId()+'/subscriber_data_mock/' +this.props.selectedSource, {headers: {authorization: getJwt()}});

            this.props.loadingSourceChange(true);
            const result = await http.get('api/subscriber_data/' + this.props.selectedSource + '/time_span/' + time_span, {headers: {authorization: getJwt()}});
            this.props.loadingSourceChange(false);

            const data = result.data;

            this.setState({subscribers_data: data.data});
            //added MOCK
            //this.setState({mock_data: data.data});
        }
    }

    getSpanData = async (data_to_send) => {
        let number = 360;
        if (data_to_send !== "Last year") {
            number = parseInt(data_to_send.replace(/[^0-9.]/g, ''), 10);
        }
        this.setState({time_span: number});
        try {
            this.setState({loader: true});
            const result = await http.get('api/subscriber_data/' + this.state.selected_source + '/time_span/' + number, {headers: {authorization: getJwt()}});
            const data = result.data;

            this.setState({
                subscribers_data: data.data,
                loader: false
            });
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    };

    render() {
        if (!this.state.selected_source
            //    && !this.state.feeds_shared
        ) {
            return (
                <React.Fragment>
                    <h1 className='main-title'>Dashboard</h1>
                    <div className="row">
                        <div className="col-xs-12 text-center no-feeds-containers">
                            <div className="feed-msg">
                                <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                                <p className="text-center ">{authService.getCurrentUserName()}</p>
                                <p>It looks like you haven't set up any workspaces yet. Add your first workspace, and
                                    start
                                    growing your audience.</p>
                                <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/>

                            </div>
                            <button className='btn-m btn-action' onClick={this.props.addSource} type="button">
                                Create your first workspace
                            </button>
                        </div>

                    </div>
                </React.Fragment>
            );
        }

        ///////                                         MONTHLY
        let myData = this.state.subscribers_data.data;

        let latest_posts = this.state.subscribers_data.latest_posts || [];

        ////////                                       FEED TOTALS
        //FEED TOTALS - ALL POSTS
        //total posts sent to feed subscribers for all facebook pages
        let sent_posts_total_all = this.state.subscribers_data.sent_posts_total || 0;
        //total posts opened = number of clicks by feed subscribers for all facebook pages
        let opened_posts_total_all = this.state.subscribers_data.opened_posts_total || 0;
        //total posts percent opened_posts_fb_total/sent_posts_fb_total posts for all facebook pages
        let percent_posts_total_all = this.state.subscribers_data.percent_posts_total || '%';

        let subscription_plan = this.state.subscribers_data.subscription_plan;
        //FEED TOTALS - SUBSCRIBERS
        //total number of subscribers for feed
        let subscribers_count_total_all = this.state.subscribers_data.subscribers_count_total || 0;
        let subscribers_count_wp_total_all = this.state.subscribers_data.subscribers_count_wp_total || 0;
        //total number of subscribers for feed for all facebook pages
        let subscribers_count_fb_total = this.state.subscribers_data.subscribers_count_fb_total || 0;
        //total number of subscribers for feed for all facebook pages all immediate subscribers
        let subscribers_count_immediate_total_all = this.state.subscribers_data.subscribers_count_immediate_total || 0;
        //total number of subscribers for feed for all facebook pages all daily subscribers
        let subscribers_count_daily_total_all = this.state.subscribers_data.subscribers_count_daily_total || 0;
        let subscribers_count_weekly_total_all = this.state.subscribers_data.subscribers_count_weekly_total || 0;
        //FEED TOTALS - BY PAGE - ALL POSTS
        //facebook pages - each totals data
        let facebook_pages_total = this.state.subscribers_data.facebook_pages || [];
        //console.log("facebook_pages_total facebook_pages_total", facebook_pages_total);
        //FEED TOTALS - FACEBOOK POSTS
        //total posts sent to feed subscribers for all facebook pages
        let sent_posts_fb_total_all = this.state.subscribers_data.sent_posts_fb_total || 0;
        //total posts opened = number of clicks by feed subscribers for all facebook pages
        let opened_posts_fb_total_all = this.state.subscribers_data.opened_posts_fb_total || 0;
        //total posts percent opened_posts_fb_total/sent_posts_fb_total posts for all facebook pages
        let percent_posts_fb_total_all = this.state.subscribers_data.percent_posts_fb_total || '%';

        //percentage of current plan usage
        let subscription_plan_percentage = '';
        if (this.state.subscribers_data.subscription_plan !== undefined) {
            subscription_plan_percentage = this.state.subscribers_data.subscription_plan.subscription_plan_percentage;
        }


        //FEED TOTALS - WEB PUSH POSTS
        //total posts sent to feed subscribers for webpush
        //let subscribers_count_wp_total = this.state.subscribers_data.subscribers_count_wp_total || 0;
        let sent_posts_wp_total = this.state.subscribers_data.sent_posts_wp_total || 0;
        //total posts sent to feed subscribers for webpush
        let opened_posts_wp_total = this.state.subscribers_data.opened_posts_wp_total || 0;
        //total posts sent to feed subscribers for webpush
        let percent_posts_wp_total = this.state.subscribers_data.percent_posts_wp_total || '%';

        //FEED TOTALS - SLACK POSTS
        //total posts sent to feed subscribers for all slack channels
        let sent_posts_slack_total = this.state.subscribers_data.sent_posts_slack_total || 0;
        //total posts sent to feed subscribers for all slack channels
        let opened_posts_slack_total = this.state.subscribers_data.opened_posts_slack_total || 0;
        //total posts sent to feed subscribers for all slack channels
        let percent_posts_slack_total = this.state.subscribers_data.percent_posts_slack_total || '%';

        //FEED TOTALS - BY CHANNEL - ALL POSTS
        //slack channels - each totals data
        let slack_channels = this.state.subscribers_data.slack_channels || [];

        ///////                                         MONTHLY
        //LABELS FOR DATA FOR MONTH, WEEK, DATE - used for values in graph
        let labels_from_response = [];

        //graph 1 values
        //total posts sent to feed subscribers by month - used for values in graph
        let sent_posts_total = [];
        //total posts opened = number of clicks by feed subscribers by month - used for values in graph
        let opened_posts_total = [];

        //total number of subscribers of feed for all facebook pages by month
        let subscribers_count_fb_month = [];
        //total number of subscribers of feed for webpush by month
        let subscribers_count_wp_total = [];
        //total number of subscribers of feed for all slack channels by month
        let subscribers_count_slack_total = [];
        //total number of new subscribers of feed by month
        let subscribers_count_total_up = [];
        //total number of old subscribers of feed who unsubscribed by month
        let subscribers_count_total_down = [];

        let fb_related_data_by_month = [];
        let fb_subscribers_by_month = [];
        let fb_acquisitions_by_month = [];

        let webpush_related_data_by_month = [];
        let webpush_subscribers_by_month = [];
        let webpush_acquisitions_by_month = [];

        let slack_related_data_by_month = [];
        let slack_subscribers_by_month = [];
        let slack_acquisitions_by_month = [];

        let dataPageRelByMonth = "";
        let dataPageSubsByMonth = "";
        let dataPageAquisByMonth = "";

        let dataChannelSlackByMonth = "";
        let dataChannelSlackSubsByMonth = "";
        let dataChannelSlackAquisByMonth = "";

        let subscribers_count_total = [];
        let subscribers_count_total_up_month = [];
        let subscribers_count_total_down_month = [];

        let count_sent = myData.length - 1;

        myData.forEach(function (entry) {
            labels_from_response[count_sent] = entry.time;
            //total posts sent to feed subscribers by month
            sent_posts_total[count_sent] = entry.sent_posts_total;
            //total posts opened = number of clicks by feed subscribers by month
            opened_posts_total[count_sent] = entry.opened_posts_total;

            subscribers_count_total[entry.time] = entry.subscribers_count_total;
            subscribers_count_total_up_month[entry.time] = entry.subscribers_count_total_up;
            subscribers_count_total_down_month[entry.time] = entry.subscribers_count_total_down;

            entry.facebook_pages && entry.facebook_pages.forEach(function (entry_fb) {
                dataPageRelByMonth += '<tr>' +
                    '<td>' + entry_fb.fb_page + '</td>' +
                    '<td>' + entry_fb.sent_posts + '/' + entry_fb.opened_posts + '</td>' +
                    '<td>' + entry_fb.percent_posts + '</td>' +
                    '</tr>';

                dataPageSubsByMonth += '<tr>' +
                    '<td>' + entry_fb.fb_page + '</td>' +
                    '<td>' + entry_fb.subscribers_count + '</td>' +
                    '</tr>';

                dataPageAquisByMonth += '<tr>' +
                    '<td>' + entry_fb.fb_page + '</td>' +
                    '<td><span class="fas fa-caret-up"></span> ' + entry_fb.subscribers_count_total_up + '</td>' +
                    '<td><span class="fas fa-caret-down"></span> ' + entry_fb.subscribers_count_total_down + '</td>' +
                    '</tr>';
            });

            fb_related_data_by_month[entry.time] = '<table class="tooltip-table m-m-b">' +
                '<thead>' +
                '<tr>' +
                '<th class="text-bold">' +
                '<span class="fab fa-facebook-messenger" data-toggle="tooltip" data-placement="top"></span> FB messenger' +
                '</th>' +
                '<th>' + entry.sent_posts_fb_total + '/' + entry.opened_posts_fb_total +
                '</th>' +
                '<th>' + entry.percent_posts_fb_total + '</th>' +
                '</tr>' +
                '</thead>' +
                '<tbody>' +
                dataPageRelByMonth +
                '</tbody>' +
                '</table>';

            fb_subscribers_by_month[entry.time] = '<table class="tooltip-table m-m-b">' +
                '<thead>' +
                '<tr>' +
                '<th class="text-bold">' +
                '<span class="fab fa-facebook-messenger" data-toggle="tooltip" data-placement="top"></span> FB messenger' +
                '</th>' +
                '<th>' + entry.subscribers_count_fb_total + '</th>' +
                '</tr>' +
                '</thead>' +
                '<tbody>' +
                dataPageSubsByMonth +
                '</tbody>' +
                '</table>';

            fb_acquisitions_by_month[entry.time] = '<table class="tooltip-table m-m-b">' +
                '<thead>' +
                '<tr>' +
                '<th class="text-bold"><span class="fab fa-facebook-messenger"></span> FB messenger</th>' +
                '<th><span class="fas fa-caret-up"></span>' + entry.subscribers_count_fb_up + '</th>' +
                '<th><span class="fas fa-caret-down"></span>' + entry.subscribers_count_fb_down + '</th>' +
                '</tr>' +
                '</thead>' +
                '<tbody>' +
                dataPageAquisByMonth +
                '</tbody>' +
                '</table>';

            webpush_related_data_by_month[entry.time] = (entry.sent_posts_wp_total) ? '<table class="tooltip-table m-m-b">' +
                '<thead>' +
                '<tr>' +
                '<th class="text-bold">' +
                '<span class="fas fa-globe" data-toggle="tooltip" data-placement="top"></span> Web Push' +
                '</th>' +
                '<th>' + entry.sent_posts_wp_total + '/' + entry.opened_posts_wp_total +
                '</th>' +
                '<th>' + entry.percent_posts_wp_total + '</th>' +
                '</tr>' +
                '</thead>' +
                '</table>'
                : '';

            webpush_subscribers_by_month[entry.time] = (entry.subscribers_count_wp_total) ? '<table class="tooltip-table m-m-b">' +
                '<thead>' +
                '<tr>' +
                '<th class="text-bold">' +
                '<span class="fas fa-globe" data-toggle="tooltip" data-placement="top"></span> Web Push' +
                '</th>' +
                '<th>' + entry.subscribers_count_wp_total + '</th>' +
                '</tr>' +
                '</thead>' +
                '</table>'
                : '';

            webpush_acquisitions_by_month[entry.time] = (entry.subscribers_count_wp_up || entry.subscribers_count_wp_down) ? '<table class="tooltip-table m-m-b">' +
                '<thead>' +
                '<tr>' +
                '<th class="text-bold">' +
                '<span class="fas fa-globe" data-toggle="tooltip" data-placement="top"></span> Web Push</th>' +
                '<th><span class="fas fa-caret-up"></span>' + entry.subscribers_count_wp_up + '</th>' +
                '<th><span class="fas fa-caret-down"></span>' + entry.subscribers_count_wp_down + '</th>' +
                '</tr>' +
                '</thead>' +
                '</table>'
                : '';

            entry.slack_channels && entry.slack_channels.forEach(function (entry_slack) {
                dataChannelSlackByMonth += '<tr>' +
                    '<td>' + entry_slack.channel + '</td>' +
                    '<td>' + entry_slack.sent_posts + '/' + entry_slack.opened_posts + '</td>' +
                    '<td>' + entry_slack.percent_posts + '</td>' +
                    '</tr>';

                dataChannelSlackSubsByMonth += '<tr>' +
                    '<td>' + entry_slack.channel + '</td>' +
                    '<td>' + entry_slack.subscribers_count + '</td>' +
                    '</tr>';

                dataChannelSlackAquisByMonth += '<tr>' +
                    '<td>' + entry_slack.channel + '</td>' +
                    '<td><span class="fas fa-caret-up"></span> ' + entry_slack.subscribers_count_up + '</td>' +
                    '<td><span class="fas fa-caret-down"></span> ' + entry_slack.subscribers_count_down + '</td>' +
                    '</tr>';

                //dataChannelSlackAquisByMonth += '<tr>'+
                //    '<td>'+ entry.channel +'</td>'+
                //    '<td><span class="fas fa-caret-up"></span> '+ entry.subscribers_count_up || "MSSU" +'</td>'+
                //    '<td><span class="fas fa-caret-down"></span> '+ entry.subscribers_count_down || "MSSD" +'</td>'+
                //    '</tr>';
            });

            slack_related_data_by_month[entry.time] = (entry.sent_posts_slack_total || entry.sent_posts_slack_total === 0) ? '<table class="tooltip-table m-m-b">' +
                '<thead>' +
                '<tr>' +
                '<th class="text-bold">' +
                '<span class="fab fab fa-slack" data-toggle="tooltip" data-placement="top"></span> Slack' +
                '</th>' +
                '<th>' + entry.sent_posts_slack_total + '/' + entry.opened_posts_slack_total +
                '</th>' +
                '<th>' + entry.percent_posts_slack_total + '</th>' +
                '</tr>' +
                '</thead>' +
                '<tbody>' +
                dataChannelSlackByMonth +
                '</tbody>' +
                '</table>'
                : '';

            slack_subscribers_by_month[entry.time] = (entry.subscribers_count_slack_total || entry.subscribers_count_slack_total === 0) ? '<table class="tooltip-table m-m-b">' +
                '<thead>' +
                '<tr>' +
                '<th class="text-bold">' +
                '<span class="fab fab fa-slack" data-toggle="tooltip" data-placement="top"></span> Slack' +
                '</th>' +
                '<th>' + entry.subscribers_count_slack_total + '</th>' +
                '</tr>' +
                '</thead>' +
                '<tbody>' +
                dataChannelSlackSubsByMonth +
                '</tbody>' +
                '</table>'
                : '';

            slack_acquisitions_by_month[entry.time] = (entry.subscribers_count_slack_up || entry.subscribers_count_slack_up === 0) ? '<table class="tooltip-table m-m-b">' +
                '<thead>' +
                '<tr>' +
                '<th class="text-bold">' +
                '<span class="fab fab fa-slack" data-toggle="tooltip" data-placement="top"></span> Slack</th>' +
                '<th><span class="fas fa-caret-up"></span>' + entry.subscribers_count_slack_up + '</th>' +
                '<th><span class="fas fa-caret-down"></span>' + entry.subscribers_count_slack_down + '</th>' +
                '</tr>' +
                '</thead>' +
                '<tbody>' +
                dataChannelSlackAquisByMonth +
                '</tbody>' +
                '</table>'
                : '';

            //graph 2 values
            //total number of subscribers of feed for all facebook pages by month
            subscribers_count_fb_month[count_sent] = entry.subscribers_count_fb_total;
            //total number of subscribers of feed for webpush by month
            subscribers_count_wp_total[count_sent] = entry.subscribers_count_wp_total;
            //total number of subscribers of feed for all slack channels by month
            subscribers_count_slack_total[count_sent] = entry.subscribers_count_slack_total;

            //graph 3 values
            //total number of new subscribers of feed by month
            subscribers_count_total_up[count_sent] = entry.subscribers_count_total_up;
            //total number of old subscribers of feed who unsubscribed by month
            subscribers_count_total_down[count_sent] = entry.subscribers_count_total_down;

            dataPageRelByMonth = "";
            dataPageSubsByMonth = "";
            dataPageAquisByMonth = "";
            dataChannelSlackByMonth = "";
            dataChannelSlackSubsByMonth = "";
            dataChannelSlackAquisByMonth = "";
            count_sent--;
        });
        if (!this.props.selectedSource) {
            return <React.Fragment>
                <h1 className='main-title'>Dashboard</h1>
                <div className="row">
                    <div className="col-xs-12 text-center no-feeds-containers">
                        <div className="feed-msg">
                            <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                            <p className="text-center ">{authService.getCurrentUserName()}</p>
                            <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/><p>It looks
                            like you haven't set up any workspaces yet. Add your first workspace, and start
                            growing
                            your audience.</p>
                        </div>
                        <button className='btn-m btn-action' onClick={this.props.addSource} type="button">
                            Create your first workspace
                        </button>
                    </div>
                </div>
            </React.Fragment>
        } else {

            return (


                <div>

                    <h1 className='main-title'>Dashboard</h1>
                    <div className="row">
                        <div className="col-lg-9">
                            <div id="performance-report" className="dash-panel m-m-b">

                                <div className="row">
                                    <PerformanceReport

                                        loadingSource={this.props.loadingSource}
                                        loader={this.state.loader}
                                        sentPerformanceReport={sent_posts_total}
                                        openedPerformanceReport={opened_posts_total}

                                        fb_related_data_by_month={fb_related_data_by_month}
                                        webpush_related_data_by_month={webpush_related_data_by_month}
                                        slack_related_data_by_month={slack_related_data_by_month}

                                        labels_from_response={labels_from_response}
                                        getSpanData={this.getSpanData}
                                        time_span={this.state.time_span}/>

                                    <NotificationStatistics
                                        sent_posts_total={sent_posts_total_all}
                                        opened_posts_total={opened_posts_total_all}
                                        percent_posts_total={percent_posts_total_all}

                                        sent_posts_fb_total={sent_posts_fb_total_all}
                                        opened_posts_fb_total={opened_posts_fb_total_all}
                                        percent_posts_fb_total={percent_posts_fb_total_all}
                                        facebook_pages_total={facebook_pages_total}

                                        sent_posts_wp_total={sent_posts_wp_total}
                                        opened_posts_wp_total={opened_posts_wp_total}
                                        percent_posts_wp_total={percent_posts_wp_total}

                                        sent_posts_slack_total={sent_posts_slack_total}
                                        opened_posts_slack_total={opened_posts_slack_total}
                                        percent_posts_slack_total={percent_posts_slack_total}
                                        slack_channels={slack_channels}/>
                                </div>
                            </div>
                            <div className="dash-panel">
                                <div className="row">
                                    <SubscribersHistory
                                        loadingSource={this.props.loadingSource}

                                        loader={this.state.loader}
                                        fb_subscribers_by_month={fb_subscribers_by_month}
                                        fb_acquisitions_by_month={fb_acquisitions_by_month}

                                        webpush_related_data_by_month={webpush_subscribers_by_month}
                                        webpush_acquisitions_by_month={webpush_acquisitions_by_month}

                                        slack_subscribers_by_month={slack_subscribers_by_month}
                                        slack_acquisitions_by_month={slack_acquisitions_by_month}

                                        subscribers_count_total={subscribers_count_total}
                                        subscribers_count_fb_month={subscribers_count_fb_month}

                                        subscribers_count_wp_total={subscribers_count_wp_total}
                                        subscribers_count_slack_total={subscribers_count_slack_total}
                                        subscribers_count_wp_total_all={subscribers_count_wp_total_all}

                                        subscribers_count_total_up={subscribers_count_total_up}
                                        subscribers_count_total_down={subscribers_count_total_down}
                                        subscribers_count_total_up_month={subscribers_count_total_up_month}
                                        subscribers_count_total_down_month={subscribers_count_total_down_month}

                                        labels_from_response={labels_from_response}
                                        getSpanData={this.getSpanData}
                                        time_span={this.state.time_span}/>

                                    <SubscribersPerChannel
                                        subscribers_count_total={subscribers_count_total_all}
                                        facebook_pages_total={facebook_pages_total}
                                        subscribers_count_wp_total={subscribers_count_wp_total_all}
                                        subscribers_count_fb_total={subscribers_count_fb_total}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            {/*{console.log('dashboard - subscription plan:', this.state.subscribers_data)}*/}
                            <TotalSubscribers
                                subscription_plan={this.state.subscribers_data.subscription_plan || {}}
                                loader={this.state.loader}
                                subscribers_count_total={subscribers_count_total_all}
                                subscribers_count_immediate_total={subscribers_count_immediate_total_all}
                                subscribers_count_daily_total={subscribers_count_daily_total_all}
                                subscribers_count_weekly_total={subscribers_count_weekly_total_all}
                                subscription_plan_percentage={subscription_plan_percentage}
                                subscription_plan_name={this.state.planName}
                                subscription_interval={this.state.interval}
                            />

                            <LatestPost latest_posts={latest_posts}/>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default Dashboard;